/**
 * @generated SignedSource<<60ede5aa1ef1d611448e04314af4386d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ContactInfoNudgeDismissMutation$variables = Record<PropertyKey, never>;
export type ContactInfoNudgeDismissMutation$data = {
  readonly dismissContactInfoNudge: {
    readonly me: {
      readonly contactInfoNudge: boolean;
      readonly id: string;
    };
  };
};
export type ContactInfoNudgeDismissMutation = {
  response: ContactInfoNudgeDismissMutation$data;
  variables: ContactInfoNudgeDismissMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DismissHubReturn",
    "kind": "LinkedField",
    "name": "dismissContactInfoNudge",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactInfoNudge",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactInfoNudgeDismissMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ContactInfoNudgeDismissMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9308070d2eb493b5c51f275004c4fd1d",
    "id": null,
    "metadata": {},
    "name": "ContactInfoNudgeDismissMutation",
    "operationKind": "mutation",
    "text": "mutation ContactInfoNudgeDismissMutation {\n  dismissContactInfoNudge {\n    me {\n      id\n      contactInfoNudge\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a37e27988876458eaed4ff1ec897a897";

export default node;
